export function distinctBy(
  value: any,
  index: number,
  self: any[],
  key: string,
) {
  return self.findIndex((v) => v[key] === value[key]) === index;
}

export function distinct(value: any, index: number, self: any[]) {
  return self.findIndex((v) => v === value) === index;
}

export function extendArray<t>(
  arr: t[] | undefined,
  len: number,
  value: t,
): t[] {
  if (arr != null && arr.length > len) {
    return arr;
  }
  const array = Array.from({ length: len }, (_, i) =>
    arr && arr[i] !== undefined ? arr[i] : value,
  );
  return array;
}
